export class ParsedFilter {
	public values: string[];

	public constructor(public readonly type: string, values?: string[]) {
		this.type = type;

		values = values ?? [];
		this.values = [...values];
	}

	public addValue(value: string): void {
		if (!this.values.includes(value)) {
			this.values.push(value);
		}
	}

	public addValues(values: string[]): void {
		const valuesExisting = new Set(this.values);
		for (const value of values) {
			if (valuesExisting.has(value)) {
				continue;
			}

			this.values.push(value);
		}
	}

	public clear(): void {
		this.values = [];
	}

	public static combine(filtersA: ParsedFilter[], filtersB: ParsedFilter[]): ParsedFilter[] {
		const result = [...filtersA];
		for (const filter of filtersB) {
			const existingFilter = result.find((_) => _.type === filter.type);
			if (existingFilter) {
				existingFilter.addValues(filter.values);
			} else {
				result.push(filter);
			}
		}

		return result;
	}
}
